export default __webpack_public_path__ + "static/media/Abyssal Demon Pendant of Dexterity.92e45a21.jpg";